module.exports = "../../../../platform/assets/pageMainIcon/industry_jichudanganlei6.svg";